<app-product-navbar [title]="product.title" [shouldShowSpecs]="shouldShowSpecs" (scrollSpecs)="scrollSpecs()" (scrollMain)="scrollMain()"></app-product-navbar>
<div #mainBox class="products-page-container" >
    <app-product-video-banner [bannerVideo]="bannerVideo" ></app-product-video-banner>

    <div>
        <div class="products-page-hero-container">
            <p class="products-page-copy-text">{{product.mainCopy}}</p>
        </div>
    </div>
    @if (product.bannerImg) {
        <div class="products-page-banner-img">
            <img  [src]="product.bannerImg">
        </div>
    }


    @if (product.boxes) {
        <div class="products-page-box-container">
            <div class="products-page-hero-container">
                @if (product.slug !== 'dock3') {
                    <div class="products-page-box-grid">
                        @for (box of product.boxes; track $index; let i = $index) {
                            <app-product-box [style.flex-grow]="product.slug === 'terra' && i === 4 ? 2 : 1" [class]="{'box-integral-data': product.slug === 'fh2' && i === 3}" [box]="box" [type]="'else'"></app-product-box>
                        }
                    </div>
                } @else {
                    <div class="products-page-dock-container">
                        <div class="products-page-dock-column">
                            <app-product-box [box]="product.boxes[0]" ></app-product-box>
                            <app-product-box [box]="product.boxes[1]" ></app-product-box>
                        </div>
                        <div class="products-page-dock-column">
                            <app-product-box [box]="product.boxes[2]" ></app-product-box>
                            <app-product-box [box]="product.boxes[3]" ></app-product-box>
                        </div>
                        <div class="products-page-dock-column">
                            <app-product-box [box]="product.boxes[4]" ></app-product-box>
                            <div class="products-page-dock-half">
                                <app-product-box [box]="product.boxes[5]" ></app-product-box>
                                <app-product-box [box]="product.boxes[6]" ></app-product-box>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    }


    @if (product.slug === 'matrice-4-td' && product.m4tdBoxes) {
        <app-m4td-boxes [boxes]="product.m4tdBoxes"></app-m4td-boxes>
    }

</div>

@if (specs && specs.length > 0) {
    <div id="specs" #specsBox class="products-page-hero-container specs">
        <app-product-specs [specs]="specs"></app-product-specs>
    </div>
}